export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  rating: number;
  latestChapter: string;
  latestChapterNum: number;
  description: string;
  views: string;
  updateDate: string;
  tags: string[];
}

export interface Chapter {
  id: string;
  comicId: string;
  number: number;
  title: string;
  updateDate: string;
}

export interface Testimonial {
  id: string;
  username: string;
  avatar: string;
  content: string;
  comicTitle: string;
  chaptersRead: number;
  rating: number;
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    slug: 'romance',
    name: '浪漫爱情',
    description: '甜蜜浪漫的爱情故事，心动瞬间尽在这里',
    icon: 'ri-heart-line',
    count: 128,
  },
  {
    slug: 'fantasy',
    name: '奇幻冒险',
    description: '穿越异世界，踏上奇幻冒险之旅',
    icon: 'ri-magic-line',
    count: 96,
  },
  {
    slug: 'action',
    name: '动作热血',
    description: '酣畅淋漓的打斗场面，热血沸腾的少年成长',
    icon: 'ri-fire-line',
    count: 85,
  },
  {
    slug: 'thriller',
    name: '悬疑惊悚',
    description: '扣人心弦的悬疑剧情，步步惊心的推理之旅',
    icon: 'ri-search-eye-line',
    count: 64,
  },
  {
    slug: 'comedy',
    name: '搞笑日常',
    description: '轻松愉快的搞笑漫画，治愈你的每一天',
    icon: 'ri-emotion-laugh-line',
    count: 72,
  },
  {
    slug: 'urban',
    name: '都市职场',
    description: '都市生活中的职场奋斗与人性百态',
    icon: 'ri-building-line',
    count: 58,
  },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '她的秘密花园',
    author: '李智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%2C%20two%20young%20adults%20in%20a%20flower%20garden%20setting%2C%20soft%20pastel%20watercolor%20illustration%2C%20clean%20white%20background%2C%20romantic%20atmosphere%2C%20beautiful%20Korean%20webtoon%20art%20style%2C%20delicate%20linework%2C%20warm%20pink%20and%20cream%20tones%2C%20editorial%20quality%20with%20subtle%20gradients&width=800&height=1100&seq=comic-cover-1&orientation=portrait',
    category: '浪漫爱情',
    categorySlug: 'romance',
    status: '连载中',
    rating: 9.6,
    latestChapter: '第128话 花开的季节',
    latestChapterNum: 128,
    description: '在首尔繁华的都市中心，隐藏着一座被遗忘的秘密花园。两个原本毫无交集的年轻人，因为这座花园意外相遇。她是一名植物学家，他是一名建筑师，命运的红线在花丛中悄然牵起，一段温暖治愈的爱情故事就此展开。当都市的喧嚣遇上花园的宁静，两个灵魂在花香中慢慢靠近。',
    views: '2.3亿',
    updateDate: '2026-07-02',
    tags: ['爱情', '治愈', '都市', '浪漫'],
  },
  {
    id: 'comic-2',
    title: '重生之财阀家的小儿子',
    author: '朴志勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20comic%20cover%2C%20a%20young%20man%20in%20luxury%20office%20suit%20standing%20confidently%2C%20corporate%20skyscraper%20background%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20art%20style%2C%20powerful%20pose%2C%20clean%20white%20background%20with%20golden%20accents%2C%20professional%20illustration%2C%20sharp%20linework&width=800&height=1100&seq=comic-cover-2&orientation=portrait',
    category: '都市职场',
    categorySlug: 'urban',
    status: '连载中',
    rating: 9.8,
    latestChapter: '第156话 董事会的较量',
    latestChapterNum: 156,
    description: '被誉为"金融界天才"的陈道俊，在一次意外中重生为韩国最大财阀家族的小儿子。带着前世的记忆和智慧，他决定改变命运，在这个充满尔虞我诈的商业帝国中杀出一条血路。商战、家族斗争、政治博弈，一场场精彩绝伦的较量轮番上演。',
    views: '5.1亿',
    updateDate: '2026-07-03',
    tags: ['重生', '商战', '家族', '逆袭'],
  },
  {
    id: 'comic-3',
    title: '暗夜追踪者',
    author: '姜敏赫',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20comic%20cover%2C%20a%20detective%20in%20dark%20coat%20standing%20in%20rainy%20alley%20at%20night%2C%20mysterious%20atmosphere%2C%20noir%20style%2C%20Korean%20webtoon%20art%20with%20dramatic%20shadows%2C%20cinematic%20lighting%2C%20clean%20white%20background%2C%20moody%20dark%20tones%20with%20neon%20accents&width=800&height=1100&seq=comic-cover-3&orientation=portrait',
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    status: '连载中',
    rating: 9.5,
    latestChapter: '第89话 真相的碎片',
    latestChapterNum: 89,
    description: '首尔连续发生离奇失踪案件，所有线索都指向一个神秘的地下组织。刑警韩志勋被调派到专案组，在追查过程中，他发现真相远比想象中更加可怕。每一个夜晚，都有新的秘密被揭开，每一个线索，都将他引向更深的黑暗。',
    views: '1.8亿',
    updateDate: '2026-07-01',
    tags: ['悬疑', '犯罪', '推理', '暗黑'],
  },
  {
    id: 'comic-4',
    title: '剑与魔法学院',
    author: '尹诗雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20comic%20cover%2C%20young%20magic%20students%20at%20a%20grand%20magical%20academy%2C%20floating%20spell%20books%20and%20glowing%20wands%2C%20fantasy%20illustration%2C%20Korean%20webtoon%20style%2C%20clean%20white%20background%2C%20vibrant%20magical%20effects%2C%20detailed%20character%20design&width=800&height=1100&seq=comic-cover-4&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 9.4,
    latestChapter: '第203话 终极试炼',
    latestChapterNum: 203,
    description: '平凡少年林浩然意外收到了一封来自"星辰魔法学院"的录取通知书。在这里，他结识了一群志同道合的伙伴，学习剑术与魔法，探索远古遗迹，对抗黑暗势力。从菜鸟学员到传奇英雄，一段波澜壮阔的奇幻冒险正式启程。',
    views: '3.6亿',
    updateDate: '2026-07-02',
    tags: ['魔法', '学院', '冒险', '成长'],
  },
  {
    id: 'comic-5',
    title: '拳王之路',
    author: '崔东旭',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20comic%20cover%2C%20a%20young%20boxer%20with%20bandaged%20fists%20in%20fighting%20stance%2C%20dynamic%20motion%2C%20intense%20expression%2C%20Korean%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20powerful%20energy%2C%20bold%20linework%2C%20action%20packed&width=800&height=1100&seq=comic-cover-5&orientation=portrait',
    category: '动作热血',
    categorySlug: 'action',
    status: '连载中',
    rating: 9.3,
    latestChapter: '第176话 冠军的荣耀',
    latestChapterNum: 176,
    description: '曾经的天才拳手张民浩，因伤退役后沦为底层打工者。但他从未放弃对拳击的热爱。当机会再次降临时，他决定重返擂台，用双拳打出属于自己的荣耀之路。每一场比赛都是生死较量，每一次出拳都承载着梦想。',
    views: '2.8亿',
    updateDate: '2026-07-03',
    tags: ['拳击', '热血', '竞技', '逆袭'],
  },
  {
    id: 'comic-6',
    title: '办公室的罗曼史',
    author: '金秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20romance%20comic%20cover%2C%20two%20office%20workers%20sharing%20a%20funny%20awkward%20moment%20at%20desks%2C%20lighthearted%20illustration%2C%20Korean%20webtoon%20style%2C%20clean%20white%20background%2C%20warm%20and%20humorous%20tone%2C%20expressive%20characters&width=800&height=1100&seq=comic-cover-6&orientation=portrait',
    category: '搞笑日常',
    categorySlug: 'comedy',
    status: '已完结',
    rating: 9.2,
    latestChapter: '第120话 幸福的开始（完）',
    latestChapterNum: 120,
    description: '职场菜鸟苏小晚入职第一天就遇到了传说中的"恶魔上司"。更糟糕的是，这位上司居然是她大学时期的暗恋对象！在啼笑皆非的办公室日常中，两人从针锋相对到暗生情愫，一段甜蜜搞笑的职场恋情就此展开。',
    views: '4.2亿',
    updateDate: '2026-06-15',
    tags: ['职场', '搞笑', '恋爱', '日常'],
  },
  {
    id: 'comic-7',
    title: '我的ID是江南美人',
    author: '韩素希',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20beauty%20comic%20cover%2C%20a%20beautiful%20young%20woman%20in%20university%20setting%2C%20elegant%20and%20confident%2C%20Korean%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20soft%20feminine%20colors%2C%20fashionable%20character%20design%2C%20chic%20illustration&width=800&height=1100&seq=comic-cover-7&orientation=portrait',
    category: '浪漫爱情',
    categorySlug: 'romance',
    status: '已完结',
    rating: 9.5,
    latestChapter: '第142话 真正的美丽（完）',
    latestChapterNum: 142,
    description: '因外貌平凡而备受困扰的女孩姜美来，通过整形手术获得了令人惊艳的美貌。进入大学后，她以为可以开始全新的人生，却意外陷入了关于外貌、爱情与自我认同的深刻思考。真正的美丽到底是什么？一段关于成长与接纳的动人故事。',
    views: '6.5亿',
    updateDate: '2026-05-20',
    tags: ['校园', '成长', '爱情', '励志'],
  },
  {
    id: 'comic-8',
    title: '末日生存法则',
    author: '郑宇成',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20post%20apocalyptic%20comic%20cover%2C%20survivors%20in%20destroyed%20city%20with%20weapons%2C%20dramatic%20and%20intense%2C%20Korean%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20dark%20atmospheric%20tones%2C%20survival%20theme&width=800&height=1100&seq=comic-cover-8&orientation=portrait',
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    status: '连载中',
    rating: 9.7,
    latestChapter: '第67话 新世界的秩序',
    latestChapterNum: 67,
    description: '一场突如其来的病毒席卷全球，文明社会在一夜之间崩塌。幸存者们必须在资源匮乏、秩序崩塌的世界中挣扎求生。高中生尹在赫带领着一群同伴，在废墟中寻找生存的希望，同时揭开病毒背后隐藏的巨大阴谋。',
    views: '3.3亿',
    updateDate: '2026-07-02',
    tags: ['末日', '生存', '丧尸', '人性'],
  },
  {
    id: 'comic-9',
    title: '龙之继承者',
    author: '安孝燮',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20dragon%20comic%20cover%2C%20a%20young%20hero%20with%20dragon%20armor%20and%20glowing%20sword%2C%20epic%20fantasy%20illustration%2C%20Korean%20webtoon%20style%2C%20clean%20white%20background%2C%20majestic%20dragon%20silhouette%2C%20heroic%20pose&width=800&height=1100&seq=comic-cover-9&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 9.6,
    latestChapter: '第189话 龙神觉醒',
    latestChapterNum: 189,
    description: '远古时代，龙族与人类曾签订永恒的盟约。千年之后，盟约的力量逐渐消散，黑暗势力蠢蠢欲动。平凡的农村少年金泰亨意外觉醒了龙之血脉，成为新一代龙之继承者。他必须找到散落世界各地的龙之碎片，唤醒沉睡的龙神，拯救濒临崩溃的世界。',
    views: '4.8亿',
    updateDate: '2026-07-03',
    tags: ['龙', '史诗', '冒险', '英雄'],
  },
];

export const testimonials: Testimonial[] = [
  {
    id: 'review-1',
    username: '漫画迷小月',
    avatar: '',
    content: '韩漫漫画网真的是我用过更新最快的平台了！《重生之财阀家的小儿子》每次都能第一时间看到最新话，画质也超清晰，推荐给所有喜欢韩漫的朋友！',
    comicTitle: '重生之财阀家的小儿子',
    chaptersRead: 156,
    rating: 5,
  },
  {
    id: 'review-2',
    username: '追更达人阿杰',
    avatar: '',
    content: '作为一个追了五年韩漫的老读者，我可以负责任地说，这个网站的阅读体验真的是一流的。加载速度极快，从来不会卡顿，而且分类很清晰，找漫画特别方便。',
    comicTitle: '剑与魔法学院',
    chaptersRead: 203,
    rating: 5,
  },
  {
    id: 'review-3',
    username: '治愈系读者',
    avatar: '',
    content: '每天晚上睡前必刷韩漫漫画网，《她的秘密花园》是我最近的心头好！画面太美了，故事情节也很温暖，每看一话都感觉被治愈了。网站界面也很清爽，阅读起来特别舒服。',
    comicTitle: '她的秘密花园',
    chaptersRead: 128,
    rating: 5,
  },
];

export const chapters: Record<string, Chapter[]> = {
  'comic-1': Array.from({ length: 128 }, (_, i) => ({
    id: `ch-1-${i + 1}`,
    comicId: 'comic-1',
    number: i + 1,
    title: `第${i + 1}话${i === 0 ? ' 花园初遇' : i === 127 ? ' 花开的季节' : ''}`,
    updateDate: `2026-${String(Math.max(1, Math.floor((127 - i) / 4))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
  })),
};